import React, { useRef, useState, useEffect } from "react";
import { Box, Grid, Typography, Button, Card, CardContent } from '@mui/material';
import styles from './styles.module.css';
import InvoiceIcon from '@mui/icons-material/Receipt';
import ExpenseIcon from '@mui/icons-material/MonetizationOn';
import AccountIcon from '@mui/icons-material/AccountBalance';
import MembershipIcon from '@mui/icons-material/CardMembership';
import VoucherIcon from '@mui/icons-material/CardGiftcard';
import PackageIcon from '@mui/icons-material/LocalOffer';
import AlertIcon from '@mui/icons-material/Notifications';
import { useLocation, useNavigate } from "react-router-dom";


const Masters = () => {
    const navigate = useNavigate();
    const userRole = JSON.parse(sessionStorage.getItem("loginUser"))?.result?.userInfo?.user_role;

    return (



  
        <Box className={`${styles.main_container}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
            <Box className={`${styles.body}`}>
                <Box className={`${styles.header_container}`}>
                    <Typography className={`${styles.header_txt}`}>Masters</Typography>
                </Box>

                <Grid container spacing={2} sx={{ padding: 2 }}>
                    {/* Invoice Configurations */}
                    <Grid item xs={12}>
                        {/* <Typography variant="h6" gutterBottom>Invoice Configurations</Typography> */}
                        <Grid container spacing={2}>
                        
                            <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-customer')}
                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>Customer</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>All Customer List & Create Customer Master </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                       
                            
                            <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-supplier')}
                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>Supplier</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>Supplier List & Create Supplier Master</Typography>
                                        </Box>
                                    </CardContent>

                                </Card>
                            </Grid>
                          
                            <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-cylinder')}

                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>Cylinder </Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>Cylinder List & Add Cylinder </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-account-manager')}

                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>Sales Officer</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>Sales Officer List & Create Sales Officer Master</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-depot')}

                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>Depot Master</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>Depot Master List & Create Depot Master</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/listplant')}

                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>Plant Master</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>Plant Master List & Create plant Master</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-industry')}

                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>Industry</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>Industry List & Create Industry Type Master</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-product')}

                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>Product</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>Product List & Create Product Master</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-driver')}

                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>Driver</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>Driver List & Create Driver Master</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                            {/* <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-user')}

                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>User</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>User List & Create User Master</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid> */}
                            <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-vehicle')}

                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>Vehicle</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>Vehicle List & Create Vehicle Master</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>



                            {/* <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-cpd')}

                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>Customer Product Details</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>Customer Product Details List & Create Product Master</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid> */}


                            {/* <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-uom')}

                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>UOM</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>UOM List & Create UOM Master</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid> */}
                            <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-location')}

                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>Location</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>Location List & Create Location Master</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                            {/* <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-rm')}

                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>RM</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>RM List & Create RM Master</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid> */}

<Grid item xs={12} sm={6} md={4}>
    <Card
        className={`${styles.getCardStyles}`}
        onClick={() => navigate('/masters/list-operator')}
    >
        <CardContent className={`${styles.CardContent}`}>
            <Box className={`${styles.iconContainer}`}>
                <InvoiceIcon className={`${styles.CardContentIcon}`} />
            </Box>
            <Box className={`${styles.Cardtitle_container}`}>
                <Typography className={`${styles.Cardtitle}`}>Operator Master</Typography>
                <Typography className={`${styles.CardSubtitle}`}>
                    Operator List &amp; Create Operator Master
                </Typography>
            </Box>
        </CardContent>
    </Card>
</Grid>


                            <Grid item xs={12} sm={6} md={4}>
                                <Card
                                    className={`${styles.getCardStyles}`}
                                    onClick={() => navigate('/masters/list-cpd')}

                                >
                                    <CardContent className={`${styles.CardContent}`}>
                                        <Box className={`${styles.iconContainer}`}>
                                            <InvoiceIcon className={`${styles.CardContentIcon}`} />
                                        </Box>
                                        <Box className={`${styles.Cardtitle_container}`}>
                                            <Typography className={`${styles.Cardtitle}`}>CPD</Typography>
                                            <Typography className={`${styles.CardSubtitle}`}>Customer Product Details</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default Masters;

